import * as classes from "./animated-dots.module.css";

export default function AnimatedDots({ width, height, color, top, ...rest }) {
  return (
    <svg height={height ?? "40"} width={width ?? "40"} className={classes.loader} {...rest}>
      <circle className={classes.dot} cx="10" cy={top ?? "20"} r="3" style={{ fill: color ?? "grey" }} />
      <circle className={classes.dot} cx="20" cy={top ?? "20"} r="3" style={{ fill: color ?? "grey" }} />
      <circle className={classes.dot} cx="30" cy={top ?? "20"} r="3" style={{ fill: color ?? "grey" }} />
    </svg>
  );
}
